import React, { useContext } from "react";
import PropTypes from "prop-types";
import { SORT_TYPES } from "config/filters";
import { GTM_CLASSNAMES } from "config/gtmSelectors";
import Select from "components/core/Select";
import SearchPageContext from "pages/SearchPageV1/SearchPageV1Context";

const SortSelect = ({
	onChange,
	selected,
	useThinSelect = false,
	labelProps = {}
}) => {
	const { setIsFiltering } = useContext(SearchPageContext);
	const handleChange = (e) => {
		setIsFiltering(true);
		onChange(e.target.value);
	};

	return (
		<Select
			className="results-sort"
			selectClassName={GTM_CLASSNAMES.SORT_SELECT}
			id="sort-select"
			label="Sort By:"
			options={Object.values(SORT_TYPES)}
			onChange={handleChange}
			defaultValue={selected}
			useThinSelect={useThinSelect}
			labelProps={labelProps}
		/>
	);
};
SortSelect.propTypes = {
	selected: PropTypes.oneOf(Object.values(SORT_TYPES).map((v) => v.value)),
	onChange: PropTypes.func.isRequired,
	useThinSelect: PropTypes.bool,
	labelProps: PropTypes.object
};

export default SortSelect;
